import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";

export default function FloatingActions() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-6 right-6 z-50 flex flex-col gap-3"
      data-testid="floating-actions"
    >
      <a
        href="https://wa.me/919886673234?text=Hi%20Edvio!%20I%20want%20to%20know%20more%20about%20your%20language%20courses."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-black/40 transition-transform duration-300 hover:scale-110"
        data-testid="whatsapp-fab"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" aria-hidden="true" />
        <MessageCircle size={22} className="relative" />
      </a>
      <a
        href="tel:9886673234"
        aria-label="Call Edvio"
        className="w-14 h-14 rounded-full bg-[#C44900] text-[#F4F4F0] flex items-center justify-center shadow-lg shadow-black/40 transition-transform duration-300 hover:scale-110"
        data-testid="call-fab"
      >
        <Phone size={20} />
      </a>
    </motion.div>
  );
}
